import { render, staticRenderFns } from "./purchase-info.vue?vue&type=template&id=1e87cad6&scoped=true"
import script from "./purchase-info.vue?vue&type=script&lang=js"
export * from "./purchase-info.vue?vue&type=script&lang=js"
import style0 from "./purchase-info.vue?vue&type=style&index=0&id=1e87cad6&prod&scoped=true&lang=scss"
import style1 from "./purchase-info.vue?vue&type=style&index=1&id=1e87cad6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87cad6",
  null
  
)

export default component.exports